import { saveAs } from 'file-saver'

export default function downloadFile(url, responseType = 'blob') {
  window.axios.get(url, {
    responseType,
  }).then(response => {
    const blob = new Blob([response.data], {
      type: response.data.type,
    })
    const contentDisposition = response.headers['content-disposition']
    const match1 = /filename\*=utf-8''(.+)/.exec(contentDisposition)
    const match2 = /filename="(.+)"/.exec(contentDisposition)
    const filename = (match1 || match2)[1]
    saveAs(blob, decodeURIComponent(filename))
  })
}
